import React, {Component} from 'react';
import './index.css';
import PropTypes from 'prop-types';
import {isAndroid, isIOS, isIOS13} from 'react-device-detect';



class SmartBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      device: '',
      isVisible: false,
      storeText: '',
      url: ''
    }
  }


  componentDidMount(){
    if(isAndroid){
      this.setState({
        device: 'android',
        isVisible: true,
        storeText: 'In Google Play',
        url: this.props.androidURL
      });
    }
    //Safari handles smart banner for IOS
/*    if(isIOS || isIOS13){
      this.setState({
        device: 'ios',
        isVisible: true,
        storeText: 'On the App Store',
        url: this.props.appleURL
      });
    }*/
  }

  closeBanner = () => {
    this.setState({
      isVisible: false
    })
  };

  render() {
    return (
      <div>
        {
          this.state.isVisible
          ?
            <div className={'bannerContainer'}>
              <div className={'leftSide'}>
                <div onClick={this.closeBanner} className={'exitButton'}>x</div>
                <div className={'imageContainer'}>
                  <img className={'logoImage'} src={this.props.appIcon} alt=""/>
                </div>
                <div className={'textContainer'}>
                  <span className={'titleText'}>{this.props.title}</span>
                  <span className={'authorText'}>{this.props.author}</span>
                  <span className={'priceText'}>{this.props.price} - {this.state.storeText}</span>
                </div>
              </div>
              <div className={'rightSide'}>
                <a href={this.state.url} className={'viewLink'}>VIEW</a>
              </div>
            </div>
            :
            null
        }
      </div>
    );
  }
}

SmartBanner.propTypes = {
  title: PropTypes.string,
  price: PropTypes.string,
  appleURL: PropTypes.string,
  androidURL: PropTypes.string,
  appIcon: PropTypes.string,
  author: PropTypes.string
};

export default SmartBanner;



// WEBPACK FOOTER //
// ./src/components/common/smartBanner/index.js